import Header from '../components/Header'
import theme from './Theme'
import { ThemeProvider } from '@mui/material/styles'
import { Box, Container, CssBaseline, Typography } from '@mui/material'
import { usePage } from '@inertiajs/react'
import { Head } from '@inertiajs/react'
import { Notification } from '../components/Notificatiion'


export default function Layout({ children, title }: { children: React.ReactNode, title: string }) {
  const { user } = usePage().props;


  return (
    <main>
      <Head title={title} />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {!!user && <Header />}
        <Notification />

        <Container sx={{ mt: 7, mb: 6, p: 0 }}>
          {children}
        </Container>
        <Box sx={{ px: 3, display: 'flex', justifyContent: 'right', alignItems: 'center', position: 'fixed', bottom: 0, height: 48, width: '100%', bgcolor: theme.pandia.blue }}>
            <Typography fontSize={11} textAlign="right" fontWeight="medium" color="#162456">© 2025 PrecisionRx by Pandia Health. All Rights Reserved.</Typography>
        </Box>
      </ThemeProvider>
    </main>
  )
}